import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  title: {
    defaultValue: 'Agrupar nichos',
    key: 'GroupNichesForm-title',
  },
  groupText: {
    defaultValue: 'Nichos para agrupar:',
    key: 'GroupNichesForm-groupText',
  },
  inputTitle: {
    defaultValue: 'Novo nome do nicho',
    key: 'GroupNichesForm-inputTitle',
  },
})
